import { render, staticRenderFns } from "./UpdateUser.vue?vue&type=template&id=007e55de&"
import script from "./UpdateUser.vue?vue&type=script&lang=ts&"
export * from "./UpdateUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports